import React from 'react';
import PropTypes from 'prop-types';
import SMMapHelper from 'components/helpers/SMMapHelper.js';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMMasterResource from 'resources/SMMasterResource.js';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';

class SMOSettingEditAddressFragmentView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.geocoder = null;

    this.state = {
      owner: this.props.owner,
      isCurrent : this.props.isCurrent,
      areas: [],
    };
  }

  componentWillMount() {
    const country_id = this.props.owner.country_id != undefined ? this.props.owner.country_id : 1;
    SMMasterResource.getLargeAreas(country_id, (data, error, xhr)=>{
      this.setState({
        areas: data
      });
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : nextProps.isCurrent,
      owner : nextProps.owner,
    });
  }

  sizeToFit() {
    let $mainTable = $("#js-split_view-main"),
        $mainTableFooter = $(this.refs.mainTableFooter);

    // main
    $mainTableFooter.outerWidth($mainTable.outerWidth());
  }

  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }

  fragmentStyle(){
    return {
      display: this.state.isCurrent ? "block" : "none"
    };
  }

  textFieldDidEndEditing(e) {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;

    if (
      (name === 'postal_code' || name === 'personal_postal_code') &&
      this.state.owner.country_id === 1
    ) {
      if (!this.geocoder) this.geocoder = new google.maps.Geocoder();

      this.geocoder.geocode({address: value}, (results, status) => {
        const address = SMMapHelper.getAddress(results, status);
        if (!address) return;

        const owner = this.state.owner;
        if (name === 'postal_code') {
          for (let i = 0; i < this.state.areas.length; i++) {
            let area = this.state.areas[i];
            if (area.name_text === address.prefecture) {
              owner.state = area.name;
              break;
            }
          }
          owner.city = address.city;
          owner.address_1 = address.address_1;
          owner.postal_code = value;
        } else if (name === 'personal_postal_code') {
          for (let i = 0; i < this.state.areas.length; i++) {
            let area = this.state.areas[i];
            if (area.name_text === address.prefecture) {
              owner.personal_state = area.name;
              break;
            }
          }
          owner.personal_city = address.city;
          owner.personal_address_1 = address.address_1;
          owner.personal_postal_code = value;
        }

        this.setState({owner: owner});
      });
    }
  }

  renderPersonalAddress() {
    const owner = this.state.owner;
    if (!owner.is_corp) return null;
    let items = [];
    for (var i = 0; i < this.state.areas.length; i++) {
      const area = this.state.areas[i];
      items.push({value: area.name, label: area.name_text});
    }

    return(
      <div>
        <SMFormFieldTitle
          title="担当者の住所"
          subTitle={<span><a href={Routes.owner_dashboard_settings_account_path(owner.username)}>{I18n.t('dashboard.label_000020')}</a>で登録した担当者の身分証明書類に記載の住所を入力してください。</span>}
          isRequired={true}
        />
        <div className="form-box">
          <div className="mb10">
            <p className="dib w160">郵便番号</p>
            <SMFormTextField
              name="personal_postal_code"
              value={owner.personal_postal_code}
              placeholderText='1600023'
              delegate={this}
              options={{className:"w100"}}
              errorText={SMFormatHelper.errorText('Owner', 'personal_postal_code', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：1600023</p>
            <SMFormValidationMessage
              name="personal_postal_code"
              errorText={SMFormatHelper.errorText('Owner', 'personal_postal_code', this.props.errors)}
            />
          </div>

          <div className="mb10">
            <p className="dib w160">都道府県・市区町村</p>
            <span className="form-select__inner">
              <label className="form-select">
                <SMFormSelectBox
                  name="personal_state"
                  items={items}
                  selectedValue={owner.personal_state}
                  delegate={this}
                />
              </label>
            </span>
            <SMFormTextField
              name="personal_city"
              value={owner.personal_city}
              placeholderText='新宿区'
              delegate={this}
              options={{className:"w300 ml5"}}
              errorText={SMFormatHelper.errorText('Owner', 'personal_city', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：東京都 新宿区</p>
            <SMFormValidationMessage
              name="personal_city"
              errorText={SMFormatHelper.errorText('Owner', 'personal_city', this.props.errors)}
            />
          </div>

          <div className="mb10">
            <p className="dib w160">町名</p>
            <SMFormTextField
              name="personal_address_1"
              value={owner.personal_address_1}
              placeholderText='西新宿'
              delegate={this}
              options={{className:"w450"}}
              errorText={SMFormatHelper.errorText('Owner', 'personal_address_1', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：西新宿</p>
            <SMFormValidationMessage
              name="personal_address_1"
              errorText={SMFormatHelper.errorText('Owner', 'personal_address_1', this.props.errors)}
            />
          </div>

          <div className="mb10">
            <p className="dib w160">番地・ビル名・部屋番号</p>
            <SMFormTextField
              name="personal_address_2"
              value={owner.personal_address_2}
              placeholderText='6-15-1ラ・トゥール新宿608'
              delegate={this}
              options={{className:"w450"}}
              errorText={SMFormatHelper.errorText('Owner', 'personal_address_2', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：6-15-1ラ・トゥール新宿608</p>
            <SMFormValidationMessage
              name="personal_address_2"
              errorText={SMFormatHelper.errorText('Owner', 'personal_address_2', this.props.errors)}
            />
          </div>
        </div>

        <SMFormFieldTitle
          title="担当者の住所（カナ）"
          subTitle={<span><a>{I18n.t('dashboard.label_000020')}</a>で登録した担当者の身分証明書類に記載の住所（カナ）を入力してください。</span>}
          isRequired={true}
        />
        <div className="form-box">
          <div className="mb10">
            <p className="dib w160">市区町村</p>
            <SMFormTextField
              name="personal_city_kana"
              value={owner.personal_city_kana}
              placeholderText='シンジュクク'
              options={{className:"w300"}}
              delegate={this}
              errorText={SMFormatHelper.errorText('Owner', 'personal_city_kana', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：シンジュクク</p>
            <SMFormValidationMessage
              name="personal_city_kana"
              errorText={SMFormatHelper.errorText('Owner', 'personal_city_kana', this.props.errors)}
            />
          </div>
          <div className="mb10">
            <p className="dib w160">町名</p>
            <SMFormTextField
              name="personal_address_1_kana"
              value={owner.personal_address_1_kana}
              placeholderText='ニシシンジュク'
              delegate={this}
              options={{className:"w450"}}
              errorText={SMFormatHelper.errorText('Owner', 'personal_address_1_kana', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：ニシシンジュク</p>
            <SMFormValidationMessage
              name="personal_address_1_kana"
              errorText={SMFormatHelper.errorText('Owner', 'personal_address_1_kana', this.props.errors)}
            />
          </div>
          <div className="mb10">
            <p className="dib w160">番地・ビル名・部屋番号</p>
            <SMFormTextField
              name="personal_address_2_kana"
              value={owner.personal_address_2_kana}
              placeholderText='6-15-1ラ・トゥールシンジュク608'
              delegate={this}
              options={{className:"w450"}}
              errorText={SMFormatHelper.errorText('Owner', 'personal_address_2_kana', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：6-15-1ラ・トゥールシンジュク608</p>
            <SMFormValidationMessage
              name="personal_address_2_kana"
              errorText={SMFormatHelper.errorText('Owner', 'personal_address_2_kana', this.props.errors)}
            />
          </div>
        </div>
      </div>
    );
  }

  renderAddress() {
    const owner = this.state.owner;
    let items = [];
    for (var i = 0; i < this.state.areas.length; i++) {
      const area = this.state.areas[i];
      items.push({value: area.name, label: area.name_text});
    }

    return(
      <div>
        <SMFormFieldTitle
          title={`${owner.is_corp ? '登記簿謄本' : '身分証明書類'}の住所`}
          subTitle={<span><a href={Routes.owner_dashboard_settings_account_path(owner.username)}>{I18n.t('dashboard.label_000020')}</a>で登録した{owner.is_corp ? '登記簿謄本' : '身分証明書類'}に記載の住所を入力してください。</span>}
          isRequired={true}
        />
        <div className="form-box">
          <div className="mb10">
            <p className="dib w160">郵便番号</p>
            <SMFormTextField
              name="postal_code"
              value={owner.postal_code}
              placeholderText='1600023'
              options={{className:"w100"}}
              delegate={this}
              errorText={SMFormatHelper.errorText('Owner', 'postal_code', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：1600023</p>
            <SMFormValidationMessage
              name="postal_code"
              errorText={SMFormatHelper.errorText('Owner', 'postal_code', this.props.errors)}
            />
          </div>

          <div className="mb10">
            <p className="dib w160">都道府県・市区町村</p>
            <span className="form-select__inner">
              <label className="form-select">
                <SMFormSelectBox
                  name="state"
                  items={items}
                  selectedValue={owner.state}
                  delegate={this}
                />
              </label>
            </span>
            <SMFormTextField
              name="city"
              value={owner.city}
              placeholderText='新宿区'
              delegate={this}
              options={{className:"w300 ml5"}}
              errorText={SMFormatHelper.errorText('Owner', 'city', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：東京都 新宿区</p>
            <SMFormValidationMessage
              name='city'
              errorText={SMFormatHelper.errorText('Owner', 'city', this.props.errors)}
            />
          </div>

          <div className="mb10">
            <p className="dib w160">町名</p>
            <SMFormTextField
              name="address_1"
              value={owner.address_1}
              placeholderText='西新宿'
              delegate={this}
              options={{className:"w450"}}
              errorText={SMFormatHelper.errorText('Owner', 'address_1', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：西新宿</p>
            <SMFormValidationMessage
              name='address_1'
              errorText={SMFormatHelper.errorText('Owner', 'address_1', this.props.errors)}
            />
          </div>

          <div className="mb10">
            <p className="dib w160">番地・ビル名・部屋番号</p>
            <SMFormTextField
              name="address_2"
              value={owner.address_2}
              placeholderText='6-15-1ラ・トゥール新宿608'
              delegate={this}
              options={{className:"w450"}}
              errorText={SMFormatHelper.errorText('Owner', 'address_2', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：6-15-1ラ・トゥール新宿608</p>
            <SMFormValidationMessage
              name='address_2'
              errorText={SMFormatHelper.errorText('Owner', 'address_2', this.props.errors)}
            />
          </div>
        </div>

        <SMFormFieldTitle
          title={`${owner.is_corp ? "登記簿謄本" : "身分証明書類"}の住所（カナ）`}
          subTitle={<span><a href={Routes.owner_dashboard_settings_account_path(owner.username)}>{I18n.t('dashboard.label_000020')}</a>で登録した{owner.is_corp ? '登記簿謄本' : '身分証明書類'}に記載の住所（カナ）を入力してください。</span>}
          isRequired={true}
        />
        <div className="form-box">
          <div className="mb10">
            <p className="dib w160">市区町村</p>
            <SMFormTextField
              name="city_kana"
              value={owner.city_kana}
              placeholderText='シンジュクク'
              delegate={this}
              options={{className:"w300"}}
              errorText={SMFormatHelper.errorText('Owner', 'city_kana', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：シンジュクク</p>
            <SMFormValidationMessage
              name='city_kana'
              errorText={SMFormatHelper.errorText('Owner', 'city_kana', this.props.errors)}
            />
          </div>
          <div className="mb10">
            <p className="dib w160">町名</p>
            <SMFormTextField
              name="address_1_kana"
              value={owner.address_1_kana}
              placeholderText='ニシシンジュク'
              delegate={this}
              options={{className:"w450"}}
              errorText={SMFormatHelper.errorText('Owner', 'address_1_kana', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：ニシシンジュク</p>
            <SMFormValidationMessage
              name='address_1_kana'
              errorText={SMFormatHelper.errorText('Owner', 'address_1_kana', this.props.errors)}
            />
          </div>
          <div className="mb10">
            <p className="dib w160">番地・ビル名・部屋番号</p>
            <SMFormTextField
              name="address_2_kana"
              value={owner.address_2_kana}
              placeholderText='6-15-1ラ・トゥールシンジュク608'
              delegate={this}
              options={{className:"w450"}}
              errorText={SMFormatHelper.errorText('Owner', 'address_2_kana', this.props.errors)}
            />
            <p className="ml170 dashboard-title__supplement">例：6-15-1ラ・トゥールシンジュク608</p>
            <SMFormValidationMessage
              name='address_2_kana'
              errorText={SMFormatHelper.errorText('Owner', 'address_2_kana', this.props.errors)}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const owner = this.state.owner;
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <form ref='form' action={Routes.owner_dashboard_settings_address_path(owner.username)} method="post">
          <input type="hidden" name="_method" value="PATCH" />
          <input type="hidden" name="authenticity_token" value={this.props.authenticityToken} />
          <p className="dashboard-lead">審査等に必要な住所情報です。</p>

          {this.renderAddress()}
          {this.renderPersonalAddress()}

          <SMFormFieldTitle title="電話番号" subTitle={"この情報は予約が確定次第ゲストと共有されます。また特定商取引法に基づく表記に記載されます。"} isRequired={true} />
          <SMFormTextFieldWithError
            name="tel"
            value={owner.tel}
            errorText={SMFormatHelper.errorText('Owner', 'tel', this.props.errors)}
            placeholderText={I18n.t('dashboard.label_000067')}
            options={{className:'w600'}}
            delegate={this}
          />

          <SMFormFieldTitle title="FAX番号" subTitle="" isRequired={false} />
          <SMFormTextFieldWithError
            name="fax"
            value={owner.fax}
            errorText={SMFormatHelper.errorText('Owner', 'fax', this.props.errors)}
            placeholderText={I18n.t('dashboard.label_000067')}
            options={{className:'w600'}}
            delegate={this}
          />

          <SMFormFieldTitle title="ウェブサイトURL" subTitle="半角英数字" isRequired={false} />
          <SMFormTextFieldWithError
            name="homepage"
            value={owner.homepage}
            errorText={SMFormatHelper.errorText('Owner', 'homepage', this.props.errors)}
            placeholderText={I18n.t('dashboard.label_000067')}
            options={{className:'w600'}}
            delegate={this}
          />

          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <input className="button-green maincol-buttonarea__button" type="submit" value="保存" />
          </div>
        </form>
      </div>
    );
  }
}

SMOSettingEditAddressFragmentView.propTypes = {
  owner: PropTypes.object.isRequired,
  delegate: PropTypes.object,
  errors: PropTypes.array,
  authenticityToken: PropTypes.string,
};
export default SMOSettingEditAddressFragmentView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/settings/SMOSettingEditAddressFragmentView.jsx